import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInputV2 from "../../../component/Select/BaseSelectorReadonlyToInputV2";

export const mapItems = (data) => {
  return {...data, id: data.friendlyName, referenceOrFriendlyName: data.friendlyName};
};

class AlertNameSelect extends BaseSelectorReadonlyToInputV2 {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Nome',
      label: 'friendlyName',
      value: 'id',
      mapItems,
      url: `alerts/v1/alerts-configurations`
    };
  }
}

AlertNameSelect.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default AlertNameSelect;



// WEBPACK FOOTER //
// ./src/pages/Alerts/Select/AlertNameSelect.js